"use client";

import React, { useState } from "react";
import { LocaleSelector } from "./LocaleSelector";
import { RegionSelector } from "./RegionSelector";
import { Locale } from "../../../../services/graphql/shared/Base";
import { usePublicConfigContext } from "../../../../providers/PublicConfigProvider";

export const RegionLocaleSelector = ({
  triggerClassName,
  labelClassName,
  containerClassName,
}: {
  readonly triggerClassName?: string;
  readonly labelClassName?: string;
  readonly containerClassName?: string;
}) => {
  const [lastSelectedLocale, setLastSelectedLocale] = useState<
    Locale | undefined
  >(undefined);

  const { LOCALIZED_IN } = usePublicConfigContext();

  return (
    <>
      <RegionSelector
        triggerClassName={triggerClassName}
        labelClassName={labelClassName}
        containerClassName={containerClassName}
        lastSelectedLocale={lastSelectedLocale}
      />
      {LOCALIZED_IN && LOCALIZED_IN.length > 1 && (
        <LocaleSelector
          triggerClassName={triggerClassName}
          labelClassName={labelClassName}
          containerClassName={containerClassName}
          lastSelectedLocale={lastSelectedLocale}
          setLastSelectedLocale={setLastSelectedLocale}
        />
      )}
    </>
  );
};
